import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { ReportDatatableModule } from '../../../shared/components/report-datatable/report-datatable.module';
import { CampaignBudgetAuditComponent } from './campaign-budget-audit.component';

@NgModule({
  declarations: [CampaignBudgetAuditComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgbDropdownModule,
    TranslateModule,
    ReportDatatableModule,
  ],
  exports: [CampaignBudgetAuditComponent],
})
export class CampaignBudgetAuditModule {}
